import { Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { TableHeader } from '../../../../../../reports/elements/TableHeader'
import { PeriodValue } from '../../../../../../reports/types/inputTypes'
import { getVisibleColumns } from '../../constants/columnConfiguration'
import { useProfitAndLossFilters } from '../../contexts/profitAndLossFiltersContext'
import * as Styled from './styled'

interface PeriodsHeaderProps {
  periods: PeriodValue[]
}

export const PeriodsHeader = ({ periods }: PeriodsHeaderProps) => {
  const { appliedFilters } = useProfitAndLossFilters()
  const visibleColumns = getVisibleColumns(appliedFilters.showChange, appliedFilters.showGroupPercentage)
  const showComparisonHeader = visibleColumns.length > 1
  const { t } = useTranslation()

  const nestedRow = (
    <tr>
      {periods?.map((period) => (
        <>
          {visibleColumns.map((column) => (
            <Styled.NestedHeaderCell key={`${period.key}-${column.key}`}>
              <Text weight="bold" alignment="right" variant="bodySM">
                {t(column.label)}
              </Text>
            </Styled.NestedHeaderCell>
          ))}
        </>
      ))}
    </tr>
  )

  const colSpan = visibleColumns.length

  return showComparisonHeader ? (
    <>
      <TableHeader isNested={true} nestedRow={nestedRow}>
        {periods?.map((period) => (
          <Styled.NestedHeaderCell key={period.key} colSpan={colSpan}>
            <Text weight="bold" variant="bodySM">
              {period.label}
            </Text>
          </Styled.NestedHeaderCell>
        ))}
      </TableHeader>
    </>
  ) : (
    <TableHeader>
      {periods?.map((period) => (
        <Styled.HeaderCell key={period.key}>
          <Text weight="bold">{period.label}</Text>
        </Styled.HeaderCell>
      ))}
    </TableHeader>
  )
}
